import DatePicker from 'primevue/datepicker'

type PopulateTime = (this: unknown, value: Date, timeString: string, ampm?: string) => void

interface IDatePickerOptions {
  methods?: { populateTime?: PopulateTime }
}

export function registerPrimeVueDatePickerManualInput() {
  const methods = (DatePicker as unknown as IDatePickerOptions).methods
  const populateTime = methods?.populateTime
  if (!methods || !populateTime) return

  // PrimeVue 4.5.5 chama ampm.toLowerCase() mesmo no formato 24h, o que impede a digitação manual de data e hora.
  methods.populateTime = function (value, timeString, ampm) {
    return populateTime.call(this, value, timeString, ampm ?? '')
  }
}
